import RemoveProjectsModal from './RemoveProjectsModal';

export default RemoveProjectsModal;
